import { render } from "./AutoriryComponent.vue?vue&type=template&id=69d26a49"
import script from "./AutoriryComponent.vue?vue&type=script&lang=js"
export * from "./AutoriryComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__